import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../mock';

function useCountUp(target, duration = 1400, start) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!start) return;
    let raf;
    const startTime = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - startTime) / duration);
      setVal(Math.floor(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);
  return val;
}

function StatItem({ s, start }) {
  const val = useCountUp(s.value, 1400, start);
  return (
    <div className="text-center">
      <div className="text-4xl sm:text-5xl font-black text-[color:var(--brand-green)]">
        {val}
        <span className="text-[color:var(--brand-orange)]">{s.suffix}</span>
      </div>
      <div className="mt-2 text-sm font-semibold text-[color:var(--ink-soft)] tracking-wide uppercase">
        {s.label}
      </div>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [start, setStart] = useState(false);
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setStart(true)),
      { threshold: 0.3 }
    );
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  return (
    <section ref={ref} className="py-16 bg-white border-y border-neutral-100">
      <div className="container-x grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((s) => (
          <StatItem key={s.label} s={s} start={start} />
        ))}
      </div>
    </section>
  );
}
